module.exports = __webpack_public_path__ + "img/ai-img-record.679a1571.png";